"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var colors_1 = require("../util/colors");
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var FullPage_1 = __importDefault(require("./FullPage"));
var NavSteps_1 = __importDefault(require("./NavSteps"));
var hooks_1 = require("../util/hooks");
var icons_1 = require("../icons");
var BBBLogo_1 = __importDefault(require("./BBBLogo"));
var IconLink_1 = __importDefault(require("./IconLink"));
var OnboardingPageFooter = function (_a) {
    var narrow = _a.narrow;
    return (react_1.default.createElement(grid_1.Container, { bt: true, px: 2, py: narrow ? 6 : 3, direction: narrow ? 'column' : 'row', align: "center", justify: narrow ? 'center' : 'space-around', wrap: false },
        react_1.default.createElement(grid_1.Container, { center: true, pb: narrow ? 6 : 0 },
            react_1.default.createElement(IconLink_1.default, { variant: "phone", trackProps: {
                    event: 'contact_click',
                    properties: { medium: 'phone', location: 'footer' },
                } })),
        react_1.default.createElement(grid_1.Container, { center: true, pb: narrow ? 6 : 0 },
            react_1.default.createElement(IconLink_1.default, { variant: "email", trackProps: {
                    event: 'contact_click',
                    properties: { medium: 'email', location: 'footer' },
                } })),
        react_1.default.createElement(grid_1.Container, { center: true, pb: narrow ? 6 : 0 },
            react_1.default.createElement(IconLink_1.default, { variant: "chat", trackProps: {
                    event: 'contact_click',
                    properties: { medium: 'chat', location: 'footer' },
                } })),
        react_1.default.createElement(grid_1.Container, { center: true },
            react_1.default.createElement(BBBLogo_1.default, { width: '120px' }))));
};
var OnboardingPage = function (_a) {
    var children = _a.children, step = _a.step, nameOverride = _a.nameOverride, hideNav = _a.hideNav, _b = _a.color, color = _b === void 0 ? colors_1.colors.white : _b, _c = _a.padContents, padContents = _c === void 0 ? true : _c, headerCenterContent = _a.headerCenterContent, HomeLinkComponent = _a.HomeLinkComponent, goBack = _a.goBack;
    var isTablet = (0, hooks_1.useBreakpoint)('md');
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, []);
    var renderHeaderCenterContent = function () {
        if (headerCenterContent) {
            return headerCenterContent;
        }
        if (step !== undefined) {
            return react_1.default.createElement(NavSteps_1.default, __assign({}, { step: step, nameOverride: nameOverride }));
        }
        var logo = (react_1.default.createElement(spacing_1.Div, { pt: 1 },
            react_1.default.createElement(icons_1.Logo, { color: colors_1.colors.primary800 })));
        return react_1.default.createElement(HomeLinkComponent, null, logo);
    };
    return (react_1.default.createElement(FullPage_1.default, { goBack: !hideNav && goBack, pad: false, headerCenterContent: renderHeaderCenterContent(), headerRightContent: !hideNav && (react_1.default.createElement(IconLink_1.default, { variant: "phone", narrow: isTablet, trackProps: {
                event: 'contact_click',
                properties: { medium: 'phone', location: 'navbar' },
            } })), footer: react_1.default.createElement(OnboardingPageFooter, { narrow: isTablet }) },
        react_1.default.createElement(spacing_1.Div, { pt: padContents ? 5 : 0, pb: padContents ? (isTablet ? 10 : 15) : 0, style: { backgroundColor: color } }, children)));
};
exports.default = OnboardingPage;
//# sourceMappingURL=OnboardingPage.js.map